import { CardMedia, IconButton, Paper, Stack, styled } from "@mui/material";
import { Close } from "@mui/icons-material";
import React from "react";
import { DraftCharacter } from "types/Draft/type";
import Constellation from "common/components/Constellation";
import { API_URL } from "service/root/rootApi";

export const BanPaperStyled = styled(Paper)(({ theme }) => ({
  width: "85px",
  height: "85px",
}));

export const PulsingBanPaper = styled(BanPaperStyled)(({ theme }) => ({
  position: "relative",
  "@keyframes pulse-ban": {
    "0%, 100%": {
      backgroundColor: "transparent",
    },
    "50%": {
      backgroundColor: theme.palette.common.player2.banCard,
    },
  },
  animation: "pulse-ban 2s infinite",
}));

export const CardMediaBanStyled = styled(
  ({ characterName, ...props }: { characterName: string }) => (
    <CardMedia
      component="img"
      src={`${API_URL}assets/genshin/characters/${characterName}/thumb.png`}
      {...props}
    />
  ),
)(() => ({
  maxHeight: "100%",
  borderRadius: "0.5rem",
}));

type DraftCharacterCardProps = {
  character: DraftCharacter;
  size?: "medium" | "small";
  onRemove?: () => void;
  hideBans?: boolean;
};

export const SelectingBan = (props: { character: DraftCharacter }) => {
  const { character } = props;

  return (
    <BanPaperStyled
      sx={{
        position: "relative",
        overflow: "hidden",
        backgroundColor: ({ palette }) => palette.common.player2.banCard,
      }}
    >
      {character.p1Constellation !== undefined && (
        <Constellation player="player1">
          {character.p1Constellation}
        </Constellation>
      )}
      {character.p2Constellation !== undefined && (
        <Constellation player="player2">
          {character.p2Constellation}
        </Constellation>
      )}
      <CardMediaBanStyled characterName={character.name} />
    </BanPaperStyled>
  );
};

export const BannedCharacter = (props: DraftCharacterCardProps) => {
  const { character, size = "medium", onRemove, hideBans } = props;
  const dimension = size === "small" ? 70 : 85;

  return (
    <BanPaperStyled
      sx={{
        position: "relative",
        overflow: "hidden",
        width: `${dimension}px`,
        height: `${dimension}px`,
      }}
    >
      {!hideBans && character.p1Constellation !== undefined && (
        <Constellation player="player1">
          {character.p1Constellation}
        </Constellation>
      )}
      {!hideBans && character.p2Constellation !== undefined && (
        <Constellation player="player2">
          {character.p2Constellation}
        </Constellation>
      )}
      <CardMediaBanStyled
        characterName={hideBans ? "Voyageur" : character.name}
        sx={{
          filter: hideBans ? "grayscale(1)" : "none",
        }}
      />
      {onRemove && (
        <Stack
          alignItems="center"
          sx={{
            position: "absolute",
            bottom: "-14px",
            width: "100%",
          }}
        >
          <IconButton
            onClick={onRemove}
            sx={{
              padding: "2px",
              margin: "auto",
              bgcolor: ({ palette }) => palette.common.player2.banCard,
              "&:hover": {
                bgcolor: ({ palette }) => palette.common.player2.paper,
              },
            }}
          >
            <Close />
          </IconButton>
        </Stack>
      )}
    </BanPaperStyled>
  );
};
